import { ErrorBase } from '~/utils/error-base';

type ErrorName = 'SIGN_UP_ERROR' | 'EMAIL_EXISTS' | 'CAPTCHA_REQUIRED';

export class QuickAuthenticationError extends ErrorBase<ErrorName> {}
